import { notyf } from '@modules';
import { pubsub } from '@services';
import { getCurrentComparisonData, makeNewComparisonData, processNewComparisonData } from '@utils';

class AddCompareButton extends HTMLElement {
  connectedCallback() {
    this.title = this.dataset.title;
    this.id = this.dataset.id;
    this.price = this.dataset.price;
    this.productImage = this.dataset.productImage;
    this.productUrl = this.dataset.productUrl;

    this.tooManyProductsMessage = this.dataset.tooManyProductsMessage;
    this.productAddedMessage = this.dataset.productAddedMessage;
    this.productRemovedMessage = this.dataset.productRemovedMessage;

    this.buttonElement = this.querySelector('button');
    this.addToCompareContent = this.querySelector('[data-add-to-compare-content]');
    this.removeFromCompareContent = this.querySelector('[data-remove-from-compare-content]');

    this.addEventListener('click', this.handleClick.bind(this));
    this.updateButtonState();
    this.unsubScribeToComparisonUpdate = pubsub.subscribe('comparison:update', (payload) =>
      this.handleUpdate(payload)
    );
  }

  disconnectedCallback() {
    if (!this.unsubScribeToComparisonUpdate) return;
    this.unsubScribeToComparisonUpdate();
  }

  updateButtonState(comparisonData) {
    const currentComparisonData = comparisonData || getCurrentComparisonData();
    this.checkDisabledState(currentComparisonData);
    this.updateContent(currentComparisonData);
  }

  updateContent(comparisonData) {
    if (!this.buttonElement || !this.addToCompareContent || !this.removeFromCompareContent) return;
    const indexOfCurrentItem = comparisonData.findIndex((item) => item.id === this.id);

    if (indexOfCurrentItem === -1) {
      this.addToCompareContent.classList.remove('hidden');
      this.removeFromCompareContent.classList.add('hidden');
    } else {
      this.addToCompareContent.classList.add('hidden');
      this.removeFromCompareContent.classList.remove('hidden');
    }
  }

  checkDisabledState(comparisonData) {
    if (!this.buttonElement) return;
    const indexOfCurrentItem = comparisonData.findIndex((item) => item.id === this.id);

    if (comparisonData.length >= 4 && indexOfCurrentItem === -1) {
      this.buttonElement.disabled = true;
    } else {
      this.buttonElement.disabled = false;
    }
  }

  handleUpdate(payload) {
    if (payload.id === this.id) return;
    this.updateButtonState(payload.newComparisonItems);
  }

  handleClick() {
    const comparisonData = getCurrentComparisonData();
    const indexOfProductInCurrentComparison = comparisonData.findIndex(
      (item) => item.id === this.id
    );
    const shouldAddProduct = indexOfProductInCurrentComparison === -1;

    if (shouldAddProduct && comparisonData.length >= 4) {
      notyf.error(this.tooManyProductsMessage);
      return;
    }

    const newData = makeNewComparisonData(
      comparisonData,
      shouldAddProduct,
      indexOfProductInCurrentComparison,
      {
        title: this.title,
        id: this.id,
        price: this.price,
        productImage: this.productImage,
        productUrl: this.productUrl,
      }
    );

    if (shouldAddProduct) {
      notyf.success(this.productAddedMessage);
      this.updateContent(newData);
    } else {
      notyf.success(this.productRemovedMessage);
      this.updateContent(newData);
    }

    processNewComparisonData(newData, this.id);
  }
}

customElements.define('add-compare-button', AddCompareButton);
